import Tooltip from '@mui/material/Tooltip';

import { roomInstance } from '@webclient/state/slices/search-session/utils/room-manager';

import FileCheckIcon from '~icons/knowz-iconify/file-check';

import { IconButton } from '@knowz/knowz-ui';

export default function FilesInRoom() {
  function logFilesInRoom() {
    const room = roomInstance.get();
    room?.localParticipant.publishData(
      new TextEncoder().encode(JSON.stringify({ modules: {} })),
      {
        reliable: true,
        topic: 'get_added_files',
      },
    );
  }

  if (import.meta.env.PROD) {
    return null;
  }

  return (
    <Tooltip
      placement="top"
      arrow
      title="only for test and dev stage, This button will console.log you all the files in the room"
    >
      <IconButton
        variant="ghost"
        color="secondary"
        onClick={logFilesInRoom}
      >
        <FileCheckIcon />
      </IconButton>
    </Tooltip>
  );
}
